import { http } from '@/plugins/http';

import type { Company } from '@/typings/company';
import type { FetchParams } from '@/plugins/http/index.d';
import type { ListedCompany, GetCompaniesParams, CreateSubCompanyPayload } from './vuex';

export default {
  async getCompanies(payload?: GetCompaniesParams): Promise<ListedCompany[]> {
    const { forceFresh = false, ...params } = payload ?? {};

    return http.fetch<ListedCompany[]>(
      'companies',
      params as FetchParams,
      undefined,
      undefined,
      forceFresh,
    );
  },

  async createCompany(payload: CreateSubCompanyPayload): Promise<Company> {
    return http.post<CreateSubCompanyPayload, Company>('companies', payload);
  },
};
